const editFAQsConstantsEn = {
  FAQsPageTitle: 'FAQs',
  FAQsPageBreadcrumb: 'FAQ',
};

export default editFAQsConstantsEn;
